import { useAppDispatch, useAppSelector } from '@App/hooks'
import { MODAL_TYPES } from '@App/redux/slices/modals/enums'
import { closeModal, isOpenCurrent, setModal } from '@App/redux/slices/modals/ModalSlice'
import { CloseIcon } from '@App/static/icons/ArrowIcons'
import { ArrowLeft } from '@App/static/icons/DashboardIcons'
import { Flag } from '@App/static/icons/Flags'
import { ArrowRightIcon } from '@App/static/icons/HomeIcons'

import { ModalTypes } from '../modalTypes'
import ModalWrapper from '../ModalWrapper'
import cn from 'clsx'
import s from './styles.module.scss'
import { Button } from '../../controls/Button'
import { useRef, useState } from 'react'
import { CheckIconGreenOutline } from '@App/static/icons/FooterIcons'
import { PencilIcon } from '@App/static/icons/AccountOrdersPageIcons'
import { EditAccountNameModal } from '../EditAccountNameModal'

export const AccountCreatedModal = ({
  isOpen,
  setIsOpen,
  id,
  currency,
  name,
}: ModalTypes & { id?: string; currency: string; name: string }) => {
  const [accountName, setAccountName] = useState(name)
  const containerRef = useRef<HTMLDivElement>(null)

  const [isEditAccountNameOpen, setIsEditAccountNameOpen] = useState(false)
  const dispatch = useAppDispatch()
  const handleOk = () => {
    dispatch(closeModal())
  }

  return (
    <ModalWrapper isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className={s.container} ref={containerRef}>
        <div className={s.header}>
          <CloseIcon className={s.closeIcon} onClick={setIsOpen} />
        </div>
        <div className={s.content}>
          <div className={s.topContainer}>
            <CheckIconGreenOutline className={s.checkIcon} />
            <div className={s.title}>Account created</div>
            <div className={s.account}>
              <div className={s.field}>
                <div className={s.name}>Type</div>
                <div className={s.value}>CFD</div>
              </div>
              <div className={s.field}>
                <div className={s.name}>Currency</div>
                <div className={s.value}>
                  <Flag code={currency} className={s.flag} /> {currency}
                </div>
              </div>
              <div className={s.field}>
                <div className={s.name}>Name</div>
                <div className={cn(s.value, s.accountName)}>
                  <span className={s.namePrefix}>Live -</span> {accountName}
                  <PencilIcon className={s.pencilIcon} onClick={() => setIsEditAccountNameOpen(true)} />
                </div>
              </div>
            </div>
          </div>
          <Button className={cn(s.btn, s.outlined, s.small)} onClick={handleOk}>
            OK
          </Button>
        </div>
        {isEditAccountNameOpen && (
          <EditAccountNameModal
            isOpen={isEditAccountNameOpen}
            setIsOpen={() => setIsEditAccountNameOpen(false)}
            id={id}
            name={name}
            parent={containerRef.current ?? undefined}
            setName={(val) => setAccountName(val)}
          />
        )}
      </div>
    </ModalWrapper>
  )
}
